<template>
  <div>
    <div class="row">

      <div class="col-6 mb-3">
        <h1>{{$t('menu.1')}}</h1>
      </div>
      <div class="col-6 mb-3 ">
        <el-button-group class="pull-right">
          <el-tooltip :content="$t('yeni')" placement="bottom">
            <el-button type="success" icon="el-icon-plus" @click="modal = true"></el-button>
          </el-tooltip>
        </el-button-group>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <el-col :span="24">
          <el-table
            :data="veri()"
            style="width: 100%">


            <el-table-column
              :label="$t('cari.adi')"
              prop="adi">
            </el-table-column>

            <el-table-column
              :label="$t('fatura.aciklama')"
              prop="aciklama">
            </el-table-column>

            <el-table-column
              :label="$t('fatura.kasaadi')"
              prop="kasa">
            </el-table-column>

            <el-table-column
              :label="$t('fatura.tarih')"
              prop="otarihi">
            </el-table-column>

            <el-table-column
              :label="$t('fatura.tutar')"
              prop="tutar">
              <template slot-scope="Data">
                <el-tag :type="Data.row.tutar <=0 ? 'danger': 'success' ">
                  <p v-if="Data.row.tutar >0 || Data.row.tutar<0">{{Money(Data.row.tutar)}}</p>
                  <p v-if="Data.row.tutar == 0">0,00</p>
                </el-tag>
              </template>
            </el-table-column>

            <el-table-column
              align="right">
              <template slot="header" slot-scope="scope">
                <el-input
                  v-model="search"
                  size="mini"
                  :placeholder="$t('ara')"/>
              </template>
              <template slot-scope="scope">
                <el-tooltip :content="$t('sil')" placement="right">
                  <el-button
                    size="mini"
                    type="danger"
                    @click="handleDelete(scope.$index, Data, scope.row)"><i class="i-Folder-Trash"></i>
                  </el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>

        </el-col>
      </div>
    </div>

    <el-dialog :title="$t('menu.1')" :visible.sync="modal">

      <el-form :model="Odeme" status-icon ref="Odeme" size="mini" label-width="120px">


        <el-form-item
          prop="Fatura_id"
          :label="$t('fatura.fatura')"
          :rules="[
          { required: true, message: $t('bos') },
          ]">
          <el-select v-model="Odeme.Fatura_id">
            <el-option
              v-for="index in Fatura"
              :key="index.id"
              :label="index.fno+' - '+index.toplam+' - '+index.cari+' - '+index.dtarihi"
              :value="index.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item
          prop="Kasa_id"
          :label="$t('fatura.kasaadi')"
          :rules="[
          { required: true, message: $t('bos') },
          ]">
          <el-select v-model="Odeme.Kasa_id">
            <el-option
              v-for="index in Kasa"
              :key="index.id"
              :label="index.adi"
              :value="index.id"></el-option>
          </el-select>
        </el-form-item>

        <hr>

        <el-form-item
          :label="$t('fatura.odemetarihi')"
          prop="otarihi"
          autocomplete="off"
          :rules="[{ required: true, message: $t('bos') }]"
        >
          <el-date-picker
            v-model="Odeme.otarihi"
            type="date"
            :placeholder="$t('fatura.odemetarihi')">
          </el-date-picker>
        </el-form-item>

        <el-form-item
          prop="aciklama"
          :label="$t('fatura.aciklama')"
          autocomplete="off"
          :rules="[{ required: true, message: $t('bos') }]">
          <el-input type="textarea" v-model="Odeme.aciklama"></el-input>
        </el-form-item>


      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="modal = false, yenimodal = false">{{$t('iptal')}}</el-button>
        <el-button type="primary" @click="onSubmit('Odeme')">{{$t('kaydet')}}</el-button>

      </span>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        Data: [],
        modal: false,
        search: '',
        Fatura: [],
        Odeme: {
          Fatura_id: "",
          Kasa_id: "",
          Cari_id: "",
          tutar: "",
          dtarihi: "",
          otarihi: "",
          aciklama: "",
          tur: "1"
        },
        Kasa: [],
        Cari:[],

        yenimodal: false,
        formLabelWidth: '180px',
      }
    },
    methods: {
      veri() {
        if (this.Data != null) {
          var veri = this.Data.filter(data => !this.search || data.adi.toLowerCase().includes(this.search.toLowerCase()))
        } else if (this.Data == '') {
          var veri = this.Data;
        }
        return veri
      },
      handleDelete(index, row, rows) {

        this.$confirm(this.$t('siluyari.0'), '', {
          confirmButtonText: this.$t('tmm'),
          cancelButtonText: this.$t('iptal'),
          type: 'warning'
        }).then(() => {

          row.splice(index, 1);
          this.$store.dispatch("Delete", {link: 'cari', id: rows.id}).then(response => {
            if (response.Status == 'OK') {
              this.$message({
                type: 'success',
                message: this.$t('siluyari.1')
              });
            } else {
              this.$message({
                type: 'danger',
                message: response.Status
              });
            }
          });


        }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('siluyari.2')
          });
        });


      },
      FaturaListele() {
        this.$store.dispatch("dataver", {method: "get", url: "/fatura/1/OK"})
          .then(response => {
            console.log(response.Data)
            if (response.Status == 'OK') {
              this.Fatura = response.Data;
            } else {

            }
          });
      },

      OdemeListele() {
        this.$store.dispatch("dataver", {method: "get", url: "/odeme/2"})
          .then(response => {
            console.log(response.Data)
            if (response.Status == 'OK') {
              this.Data = response.Data;
              console.log(this.Data);
            } else {

            }
          });
      },

      KasaListele() {
        this.$store.dispatch("dataver", {method: "get", url: "/kasa"})
          .then(response => {
            if (response.Status == 'OK') {
              this.Kasa = response.Data;
            } else {

            }
          });
      },
      CariListele() {
        this.$store.dispatch("dataver", {method: "get", url: "/cari"})
          .then(response => {
            if (response.Status == 'OK') {
              this.Cari = response.Data;
            } else {

            }
          });
      },
      onSubmit(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.$store.dispatch("dataver", {
              method: 'post',
              url: '/odeme/',
              data: this.Odeme
            }).then(response => {
              console.log(response)
              if (response.Status == 'OK') {
                this.OdemeListele();
                this.FaturaListele();
                this.modal = false;
                this.$message({
                  type: 'success',
                  message: this.$t('siluyari.1')
                });
              } else {

              }
            })


          }
        });
      },

      Money(value) {
        let val = (value / 1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },
    },
    created() {
      this.KasaListele()
      this.OdemeListele()
      this.FaturaListele()
      this.CariListele()

    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/Module/gelir/odeme/liste.vue